// extracted by mini-css-extract-plugin
module.exports = {"playButton":"playButton__2x7dg","playButtonShadow":"playButtonShadow__1r60J","image":"image__28iKC","video":"video__c6kBG","overlay":"overlay__1sutX","link":"link__26ixP"};